export default {
  'user-groups.title': 'Gestionar Grupos de Usuarios',
  'user-groups.groupUsers.description': 'Agregue o retire usuarios del grupo {name}.',
  'user-groups.userExists': 'El usuario ya pertenece a este grupo',
};
